/* JS homepage Etchelle. Sinh boi rh-js.mjs -- SUA O DO, dung sua file nay. */
/* ===== STUB: LazyLoad (thu vien goc da bi go) ===== */
window.LazyLoad = window.LazyLoad || function () {
  return { update: function () {}, loadAll: function () {}, destroy: function () {} };
};

/* ===== GOC: ecomwize_y_ltx_hi_ct_a_CR4Gnj-2.js -- carousel khoi 1 ===== */
(function(){
try {

(function() {
  function initHero07Swiper() {
    if (typeof Swiper === 'undefined') return;
    
    var container = document.querySelector('#ecomwize-hero07-YLtxHi_CtA .hero07-swiper');
    if (!container || container.swiper) return;
    
    new Swiper(container, {
      slidesPerView: 1,
      spaceBetween: 20,
      loop: true,
      pagination: {
        el: '#ecomwize-hero07-YLtxHi_CtA .swiper-pagination',
        clickable: true,
      },
    });
  }
  
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initHero07Swiper);
  } else {
    initHero07Swiper();
  }
})();

} catch (e) { if (window.console) console.warn('[rh] ecomwize_y_ltx_hi_ct_a_CR4Gnj-2:', e); }
})();

/* ===== GOC: ecomwize_0zqp_pcj_q83_Xqezk4-2.js -- carousel banner ===== */
(function(){
try {

(function(){
  var SLIDE_WIDTH = 280;
  var MOBILE_GAP = 24;
  var DESKTOP_GAP = 48;
  var MOBILE_BREAKPOINT = 1024;
  
  function isMobile() {
    return window.innerWidth < MOBILE_BREAKPOINT;
  }
  
  function checkAllSlidesVisible() {
    if (isMobile()) return false;
    var container = document.querySelector('#ecomwize-banner03-0zqpPcjQ83 .banner03-swiper-container');
    if (!container) return false;
    var availableWidth = container.offsetWidth;
    var totalWidth = (4 * SLIDE_WIDTH) + ((4 - 1) * DESKTOP_GAP);
    return totalWidth <= availableWidth;
  }
  
  function updateNavVisibility(swiper) {
    var navContainer = document.querySelector('#ecomwize-banner03-0zqpPcjQ83 .banner03-nav-container');
    var swiperEl = document.querySelector('#ecomwize-banner03-0zqpPcjQ83 .banner03-swiper');
    if (!navContainer || !swiperEl) return;
    
    var allVisible = checkAllSlidesVisible();
    
    if (allVisible) {
      navContainer.classList.add('hidden');
      swiperEl.style.width = 'fit-content';
      swiperEl.style.marginLeft = 'auto';
      swiperEl.style.marginRight = 'auto';
    } else {
      navContainer.classList.remove('hidden');
      swiperEl.style.width = '100%';
      swiperEl.style.marginLeft = '0';
      swiperEl.style.marginRight = '0';
    }
    
    updateDots(swiper);
  }
  
  function updateDots(swiper) {
    var dotsContainer = document.querySelector('#ecomwize-banner03-0zqpPcjQ83 .banner03-nav-dots');
    if (!dotsContainer || !swiper.snapGrid) return;
    
    var totalSnaps = swiper.snapGrid.length;
    var currentSnap = swiper.snapIndex || 0;
    var existingDots = dotsContainer.querySelectorAll('.banner03-nav-dot');
    
    if (existingDots.length !== totalSnaps) {
      dotsContainer.innerHTML = '';
      for (var i = 0; i < totalSnaps; i++) {
        var dot = document.createElement('span');
        dot.className = 'banner03-nav-dot' + (i === currentSnap ? ' active' : '');
        dot.setAttribute('data-index', i);
        dot.onclick = (function(index) {
          return function() { swiper.slideTo(index); };
        })(i);
        dotsContainer.appendChild(dot);
      }
    } else {
      existingDots.forEach(function(dot, i) {
        if (i === currentSnap) {
          dot.classList.add('active');
        } else {
          dot.classList.remove('active');
        }
      });
    }
  }
  
  function initBanner03Swiper() {
    if (typeof Swiper === 'undefined') return;
    var container = document.querySelector('#ecomwize-banner03-0zqpPcjQ83 .banner03-swiper');
    if (!container || container.swiper) return;
    
    var prevBtn = document.querySelector('#ecomwize-banner03-0zqpPcjQ83 .banner03-nav-prev');
    var nextBtn = document.querySelector('#ecomwize-banner03-0zqpPcjQ83 .banner03-nav-next');
    var mobile = isMobile();
    
    var swiper = new Swiper(container, {
      slidesPerView: 'auto',
      spaceBetween: mobile ? MOBILE_GAP : DESKTOP_GAP,
      centeredSlides: mobile,
      loop: false,
      navigation: {
        nextEl: nextBtn,
        prevEl: prevBtn,
        disabledClass: 'disabled'
      },
      on: {
        init: function() { updateNavVisibility(this); },
        snapIndexChange: function() { updateDots(this); },
        resize: function() {
          var nowMobile = isMobile();
          this.params.spaceBetween = nowMobile ? MOBILE_GAP : DESKTOP_GAP;
          this.params.centeredSlides = nowMobile;
          this.update();
          updateNavVisibility(this);
        }
      }
    });
    
    var resizeTimeout;
    window.addEventListener('resize', function() {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(function() {
        if (swiper && !swiper.destroyed) {
          var nowMobile = isMobile();
          swiper.params.spaceBetween = nowMobile ? MOBILE_GAP : DESKTOP_GAP;
          swiper.params.centeredSlides = nowMobile;
          swiper.update();
          updateNavVisibility(swiper);
        }
      }, 100);
    });
  }
  
  if (typeof Swiper !== 'undefined') { initBanner03Swiper(); }
  else { document.addEventListener('swiper:loaded', initBanner03Swiper); }
  if (document.readyState === 'complete') { initBanner03Swiper(); }
  else { window.addEventListener('load', initBanner03Swiper); }
})();

} catch (e) { if (window.console) console.warn('[rh] ecomwize_0zqp_pcj_q83_Xqezk4-2:', e); }
})();

/* ===== GOC: ecomwize_s3_rr_ky_y2_xp_PBgXUr-2.js -- carousel testimonial ===== */
(function(){
try {

(function(){
  var SLIDE_WIDTH = 360;
  var MOBILE_GAP = 16;
  var DESKTOP_GAP = 16;
  var MOBILE_BREAKPOINT = 1024;
  
  function isMobile() {
    return window.innerWidth < MOBILE_BREAKPOINT;
  }
  
  function checkAllSlidesVisible() {
    if (isMobile()) return false;
    var container = document.querySelector('#ecomwize-testimonial05-s3RRKyY2Xp .testimonial05-swiper-container');
    if (!container) return false;
    var availableWidth = container.offsetWidth;
    var totalWidth = (4 * SLIDE_WIDTH) + ((4 - 1) * DESKTOP_GAP);
    return totalWidth <= availableWidth;
  }
  
  function updateNavVisibility(swiper) {
    var navContainer = document.querySelector('#ecomwize-testimonial05-s3RRKyY2Xp .testimonial05-nav-container');
    var swiperEl = document.querySelector('#ecomwize-testimonial05-s3RRKyY2Xp .testimonial05-swiper');
    if (!navContainer || !swiperEl) return;
    
    var allVisible = checkAllSlidesVisible();
    
    if (allVisible) {
      navContainer.classList.add('hidden');
      swiperEl.style.width = 'fit-content';
      swiperEl.style.marginLeft = 'auto';
      swiperEl.style.marginRight = 'auto';
    } else {
      navContainer.classList.remove('hidden');
      swiperEl.style.width = '100%';
      swiperEl.style.marginLeft = '0';
      swiperEl.style.marginRight = '0';
    }
    
    updateDots(swiper);
  }
  
  function updateDots(swiper) {
    var dotsContainer = document.querySelector('#ecomwize-testimonial05-s3RRKyY2Xp .testimonial05-nav-dots');
    if (!dotsContainer || !swiper.snapGrid) return;
    
    var totalSnaps = swiper.snapGrid.length;
    var currentSnap = swiper.snapIndex || 0;
    var existingDots = dotsContainer.querySelectorAll('.testimonial05-nav-dot');
    
    if (existingDots.length !== totalSnaps) {
      dotsContainer.innerHTML = '';
      for (var i = 0; i < totalSnaps; i++) {
        var dot = document.createElement('span');
        dot.className = 'testimonial05-nav-dot' + (i === currentSnap ? ' active' : '');
        dot.setAttribute('data-index', i);
        dot.onclick = (function(index) {
          return function() { swiper.slideTo(index); };
        })(i);
        dotsContainer.appendChild(dot);
      }
    } else {
      existingDots.forEach(function(dot, i) {
        if (i === currentSnap) {
          dot.classList.add('active');
        } else {
          dot.classList.remove('active');
        }
      });
    }
  }
  
  function initTestimonial05Swiper() {
    if (typeof Swiper === 'undefined') return;
    var container = document.querySelector('#ecomwize-testimonial05-s3RRKyY2Xp .testimonial05-swiper');
    if (!container || container.swiper) return;
    
    var prevBtn = document.querySelector('#ecomwize-testimonial05-s3RRKyY2Xp .testimonial05-nav-prev');
    var nextBtn = document.querySelector('#ecomwize-testimonial05-s3RRKyY2Xp .testimonial05-nav-next');
    var mobile = isMobile();
    
    var swiper = new Swiper(container, {
      slidesPerView: 'auto',
      spaceBetween: mobile ? MOBILE_GAP : DESKTOP_GAP,
      centeredSlides: mobile,
      loop: false,
      navigation: {
        nextEl: nextBtn,
        prevEl: prevBtn,
        disabledClass: 'disabled'
      },
      on: {
        init: function() { updateNavVisibility(this); },
        snapIndexChange: function() { updateDots(this); },
        resize: function() {
          var nowMobile = isMobile();
          this.params.spaceBetween = nowMobile ? MOBILE_GAP : DESKTOP_GAP;
          this.params.centeredSlides = nowMobile;
          this.update();
          updateNavVisibility(this);
        }
      }
    });
    
    var resizeTimeout;
    window.addEventListener('resize', function() {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(function() {
        if (swiper && !swiper.destroyed) {
          var nowMobile = isMobile();
          swiper.params.spaceBetween = nowMobile ? MOBILE_GAP : DESKTOP_GAP;
          swiper.params.centeredSlides = nowMobile;
          swiper.update();
          updateNavVisibility(swiper);
        }
      }, 100);
    });
  }
  
  if (typeof Swiper !== 'undefined') { initTestimonial05Swiper(); }
  else { document.addEventListener('swiper:loaded', initTestimonial05Swiper); }
  if (document.readyState === 'complete') { initTestimonial05Swiper(); }
  else { window.addEventListener('load', initTestimonial05Swiper); }
})();

} catch (e) { if (window.console) console.warn('[rh] ecomwize_s3_rr_ky_y2_xp_PBgXUr-2:', e); }
})();

/* ===== GOC: ecomwize_xla_re_mdk_sn_NCKiyY-2.js -- carousel khoi 4 ===== */
(function(){
try {

(function(){
  var SLIDE_WIDTH = 360;
  var MOBILE_GAP = 16;
  var DESKTOP_GAP = 16;
  var MOBILE_BREAKPOINT = 1024;
  
  function isMobile() {
    return window.innerWidth < MOBILE_BREAKPOINT;
  }
  
  function checkAllSlidesVisible() {
    if (isMobile()) return false;
    var container = document.querySelector('#ecomwize-testimonial03-XlaREMdkSN .testimonial03-swiper-container');
    if (!container) return false;
    var availableWidth = container.offsetWidth;
    var totalWidth = (5 * SLIDE_WIDTH) + ((5 - 1) * DESKTOP_GAP);
    return totalWidth <= availableWidth;
  }
  
  function updateNavVisibility(swiper) {
    var navContainer = document.querySelector('#ecomwize-testimonial03-XlaREMdkSN .testimonial03-nav-container');
    var swiperEl = document.querySelector('#ecomwize-testimonial03-XlaREMdkSN .testimonial03-swiper');
    if (!navContainer || !swiperEl) return;
    
    var allVisible = checkAllSlidesVisible();
    
    if (allVisible) {
      navContainer.classList.add('hidden');
      swiperEl.style.width = 'fit-content';
      swiperEl.style.marginLeft = 'auto';
      swiperEl.style.marginRight = 'auto';
    } else {
      navContainer.classList.remove('hidden');
      swiperEl.style.width = '100%';
      swiperEl.style.marginLeft = '0';
      swiperEl.style.marginRight = '0';
    }
    
    updateDots(swiper);
  }
  
  function updateDots(swiper) {
    var dotsContainer = document.querySelector('#ecomwize-testimonial03-XlaREMdkSN .testimonial03-nav-dots');
    if (!dotsContainer || !swiper.snapGrid) return;
    
    var totalSnaps = swiper.snapGrid.length;
    var currentSnap = swiper.snapIndex || 0;
    var existingDots = dotsContainer.querySelectorAll('.testimonial03-nav-dot');
    
    if (existingDots.length !== totalSnaps) {
      dotsContainer.innerHTML = '';
      for (var i = 0; i < totalSnaps; i++) {
        var dot = document.createElement('span');
        dot.className = 'testimonial03-nav-dot' + (i === currentSnap ? ' active' : '');
        dot.setAttribute('data-index', i);
        dot.onclick = (function(index) {
          return function() { swiper.slideTo(index); };
        })(i);
        dotsContainer.appendChild(dot);
      }
    } else {
      existingDots.forEach(function(dot, i) {
        if (i === currentSnap) {
          dot.classList.add('active');
        } else {
          dot.classList.remove('active');
        }
      });
    }
  }
  
  function initTestimonial03Swiper() {
    if (typeof Swiper === 'undefined') return;
    var container = document.querySelector('#ecomwize-testimonial03-XlaREMdkSN .testimonial03-swiper');
    if (!container || container.swiper) return;
    
    var prevBtn = document.querySelector('#ecomwize-testimonial03-XlaREMdkSN .testimonial03-nav-prev');
    var nextBtn = document.querySelector('#ecomwize-testimonial03-XlaREMdkSN .testimonial03-nav-next');
    var mobile = isMobile();
    
    var swiper = new Swiper(container, {
      slidesPerView: 'auto',
      spaceBetween: mobile ? MOBILE_GAP : DESKTOP_GAP,
      centeredSlides: mobile,
      loop: false,
      navigation: {
        nextEl: nextBtn,
        prevEl: prevBtn,
        disabledClass: 'disabled'
      },
      on: {
        init: function() { updateNavVisibility(this); },
        snapIndexChange: function() { updateDots(this); },
        resize: function() {
          var nowMobile = isMobile();
          this.params.spaceBetween = nowMobile ? MOBILE_GAP : DESKTOP_GAP;
          this.params.centeredSlides = nowMobile;
          this.update();
          updateNavVisibility(this);
        }
      }
    });
    
    var resizeTimeout;
    window.addEventListener('resize', function() {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(function() {
        if (swiper && !swiper.destroyed) {
          var nowMobile = isMobile();
          swiper.params.spaceBetween = nowMobile ? MOBILE_GAP : DESKTOP_GAP;
          swiper.params.centeredSlides = nowMobile;
          swiper.update();
          updateNavVisibility(swiper);
        }
      }, 100);
    });
  }
  
  if (typeof Swiper !== 'undefined') { initTestimonial03Swiper(); }
  else { document.addEventListener('swiper:loaded', initTestimonial03Swiper); }
  if (document.readyState === 'complete') { initTestimonial03Swiper(); }
  else { window.addEventListener('load', initTestimonial03Swiper); }
})();

} catch (e) { if (window.console) console.warn('[rh] ecomwize_xla_re_mdk_sn_NCKiyY-2:', e); }
})();

/* ===== GOC: ecomwize_n_f8lys_c_hvn_UHdKbe-2.js -- carousel khoi cuoi ===== */
(function(){
try {

(function(){
  function initInstruction03Swiper(){
    if(typeof Swiper==='undefined')return;
    var container=document.querySelector('#ecomwize-instruction03-nF8lysCHvn .instruction03-swiper');
    if(!container||container.swiper)return;
    
    var prevBtn=document.querySelector('#ecomwize-instruction03-nF8lysCHvn .instruction03-nav-prev');
    var nextBtn=document.querySelector('#ecomwize-instruction03-nF8lysCHvn .instruction03-nav-next');
    
    var swiper=new Swiper(container,{
      slidesPerView:'auto',
      spaceBetween:16,
      centeredSlides:true,
      loop:false,
      navigation:{
        nextEl:nextBtn,
        prevEl:prevBtn,
        disabledClass:'disabled'
      },
      pagination:{
        el:'#ecomwize-instruction03-nF8lysCHvn .instruction03-nav-dots',
        clickable:true,
        bulletClass:'instruction03-nav-dot',
        bulletActiveClass:'active'
      }
    });
  }
  
  if(typeof Swiper!=='undefined'){initInstruction03Swiper();}
  else{document.addEventListener('swiper:loaded',initInstruction03Swiper);}
  if(document.readyState==='complete'){initInstruction03Swiper();}
  else{window.addEventListener('load',initInstruction03Swiper);}
})();

} catch (e) { if (window.console) console.warn('[rh] ecomwize_n_f8lys_c_hvn_UHdKbe-2:', e); }
})();

/* ===== GOC: store_faq_fVL7z8-1.js -- FAQ ===== */
(function(){
try {

  (function () {
    'use strict';

    const sectionInstances = new WeakMap();
    const activeSections = new Set();

    let globalResizeHandler = null;
    let resizeHandlerAttached = false;

    class FAQSection {
      constructor(rootElement) {
        this.root = rootElement;
        this.clickHandler = null;
        this.mutationObserver = null;
        this.initialized = false;
      }

      init() {
        if (this.initialized) return;

        this.setupClickHandler();
        this.setupMutationObserver();
        this.updateResponsiveFontSizes();
        this.initialized = true;
      }

      setupClickHandler() {
        if (this.clickHandler) return;

        this.clickHandler = (e) => {
          const questionEl = e.target.closest('.store-faq-question');
          if (!questionEl || !this.root.contains(questionEl)) return;

          e.preventDefault();
          e.stopPropagation();

          const item = questionEl.closest('.store-faq-item');
          if (!item) return;

          const columnContainer = questionEl.closest('.store-faq-items-container');
          if (!columnContainer) return;

          const scopeIsAccordion = columnContainer.getAttribute('data-accordion') === 'true';

          if (scopeIsAccordion && !item.classList.contains('active')) {
            const activeItems = columnContainer.querySelectorAll('.store-faq-item.active');
            activeItems.forEach((other) => {
              if (other !== item && !other.classList.contains('mobile-only-item')) {
                other.classList.remove('active');
              }
            });
          }

          item.classList.toggle('active');
        };

        this.root.addEventListener('click', this.clickHandler, true);
      }

      setupMutationObserver() {
        if (this.mutationObserver) return;

        this.mutationObserver = new MutationObserver((mutations) => {
          for (const m of mutations) {
            if (m.type === 'childList' && (m.addedNodes.length || m.removedNodes.length)) {
              this.init();
              break;
            }
          }
        });

        this.mutationObserver.observe(this.root, { childList: true, subtree: true });
      }

      updateResponsiveFontSizes() {
        if (!this.root) return;

        const isMobile = window.innerWidth < 750;
        if (isMobile) {
          document.documentElement.classList.add('faq-mobile-view');
        } else {
          document.documentElement.classList.remove('faq-mobile-view');
        }
      }

      cleanup() {
        if (this.clickHandler) {
          this.root.removeEventListener('click', this.clickHandler, true);
          this.clickHandler = null;
        }

        if (this.mutationObserver) {
          this.mutationObserver.disconnect();
          this.mutationObserver = null;
        }

        this.initialized = false;
      }
    }

    function getOrCreateFAQSection(sectionId) {
      const root = document.querySelector(`#store-faq-${sectionId}`);
      if (!root) return null;
      let instance = sectionInstances.get(root);

      if (!instance) {
        instance = new FAQSection(root);
        sectionInstances.set(root, instance);
        activeSections.add(instance);
      }

      return instance;
    }

    // Start FAQ section
    function initFAQ() {
      const instance = getOrCreateFAQSection('template--29945056887158__store_faq_fVL7z8');
      if (!instance) {
        setTimeout(initFAQ, 100);
        return;
      }

      instance.init();
    }

    function cleanupFAQ() {
      const root = document.querySelector('#store-faq-template--29945056887158__store_faq_fVL7z8');
      if (!root) return;

      const instance = sectionInstances.get(root);
      if (instance) {
        instance.cleanup();
        activeSections.delete(instance);
        sectionInstances.delete(root);
      }
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initFAQ);
    } else {
      initFAQ();
    }

    // Shopify JS hooks
    document.addEventListener('shopify:section:load', function (evt) {
      if (!evt.detail || evt.detail.sectionId !== 'template--29945056887158__store_faq_fVL7z8') return;
      initFAQ();
    });

    document.addEventListener('shopify:section:select', function (evt) {
      if (!evt.detail || evt.detail.sectionId !== 'template--29945056887158__store_faq_fVL7z8') return;
      initFAQ();
    });

    document.addEventListener('shopify:section:reorder', function (evt) {
      if (!evt.detail || evt.detail.sectionId !== 'template--29945056887158__store_faq_fVL7z8') return;
      initFAQ();
    });

    document.addEventListener('shopify:section:unload', function (evt) {
      if (!evt.detail || evt.detail.sectionId !== 'template--29945056887158__store_faq_fVL7z8') return;
      cleanupFAQ();
    });
    // Redundancy fallback
    window.addEventListener('load', initFAQ);
  })();

} catch (e) { if (window.console) console.warn('[rh] store_faq_fVL7z8-1:', e); }
})();

/* ===== TU VIET: rt-src/page.js ===== */
/* JS cho trang Korean Hair Revival Serum.
 *
 * File RIENG, khong viet thang vao template literal cua rt-assemble.mjs.
 * Ly do: trong template literal cua JS, day "\." bi hieu la escape va tra ve
 * "." -- nen regex /(\.[a-z]+)(\?|$)/ bien thanh /(.[a-z]+)(?|$)/, la regex
 * sai cu phap, va CA KHOI script chet im lang. Da dinh mot lan: dong ho, gio
 * hang va Swiper deu khong chay ma trang van trong binh thuong.
 * Doc file bang readFileSync thi khong co lop escape nao can giua.
 *
 * Ban goc co 38 script (theme + app ecomwize), da go het vi khong kiem soat
 * duoc ma cua ben thu ba. File nay viet lai dung nhung gi can thiet.
 *
 * Co dung mot placeholder cho don vi tien, rt-assemble thay bang Liquid luc
 * ghep. Khong viet lai ten placeholder o day: neu no xuat hien hai lan thi
 * .replace() voi chuoi chi doi lan dau, va lan dau lai la dong comment nay.
 */
(function () {
  'use strict';

  var $ = function (s) { return document.querySelector(s); };
  var $$ = function (s) { return Array.prototype.slice.call(document.querySelectorAll(s)); };

  // Moi phan doc lap nhau: mot phan hong khong duoc keo do nhung phan con
  // lai. Day chinh la cai da xay ra lan truoc.
  var safe = function (name, fn) {
    try { fn(); } catch (e) {
      if (window.console && console.warn) console.warn('[rt] ' + name + ':', e);
    }
  };

  // ---------- 1. Carousel: chi la LUOI DO PHONG ----------
  // Script goc cua roothrive da lo phan carousel va chay truoc. Ham nay chi
  // vot nhung .swiper nao con sot lai -- bo qua cai da duoc Swiper khoi tao
  // (Swiper tu gan class .swiper-initialized). Khong kiem tra thi se khoi
  // tao chong len nhau va carousel nhay lung tung.
  function initSwipers() {
    if (typeof Swiper === 'undefined') return;
    $$('.swiper').forEach(function (el) {
      if (el.dataset.inited || el.classList.contains('swiper-initialized')) return;
      if (!el.querySelector('.swiper-wrapper')) return;
      el.dataset.inited = '1';
      // KHONG dung loop va autoplay. Ban goc khong dung (da doi chieu), va
      // loop khien Swiper NHAN BAN slide -- ban sao khong co src nen video
      // trong do se dung im o anh poster. Giu dung cau hinh goc.
      try {
        new Swiper(el, {
          slidesPerView: 'auto',
          spaceBetween: 16,
          navigation: {
            nextEl: el.querySelector('.swiper-button-next'),
            prevEl: el.querySelector('.swiper-button-prev'),
          },
          pagination: { el: el.querySelector('.swiper-pagination'), clickable: true },
        });
      } catch (e) {}
    });
  }

  // ---------- 2. Dong ho dem nguoc ----------
  // Moc het han luu theo tung khach: lam moi trang khong lam dong ho nhay
  // lai tu dau. Het han thi day sang moc ke tiep, khong bao gio hien 00:00:00.
  function initTimer() {
    var el = document.querySelector('[data-rt-timer]');
    if (!el) return;
    var SPAN = 5 * 60 * 60 * 1000;
    var KEY = 'rt-timer-hairserum';
    var pad = function (n) { return n < 10 ? '0' + n : '' + n; };

    var deadline = 0;
    try { deadline = parseInt(localStorage.getItem(KEY), 10) || 0; } catch (e) {}
    if (!deadline) deadline = Date.now() + SPAN;
    while (deadline <= Date.now()) deadline += SPAN;
    try { localStorage.setItem(KEY, String(deadline)); } catch (e) {}

    var tick = function () {
      var left = deadline - Date.now();
      if (left <= 0) {
        deadline += SPAN;
        try { localStorage.setItem(KEY, String(deadline)); } catch (e) {}
        left = deadline - Date.now();
      }
      var s = Math.floor(left / 1000);
      el.textContent = pad(Math.floor(s / 3600)) + ':' + pad(Math.floor(s / 60) % 60) + ':' + pad(s % 60);
    };
    tick();
    setInterval(tick, 1000);
  }

  // ---------- 3. Gio hang truot ----------
  // Layout 'advertorial' khong nap JS cua theme nen khong co drawer san.
  // Bam ADD TO CART: true = sang thang /checkout; false = mo gio hang truot.
  // Loi (het hang, mang hong...) thi luon mo drawer de hien thong bao.
  var SKIP_CART = true;

  function initCart() {
    var panel = $('#rt-cart');
    var overlay = $('#rt-cart-overlay');
    if (!panel || !overlay) return;

    // File nay la asset .js thuan (khong qua Liquid) nen khong nhung bien
    // tien te cua shop vao duoc. Shopify tu cap window.Shopify.currency.active
    // tren moi trang storefront -- dung no, va theo ca khi khach doi tien te.
    var currency = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD';
    var money = function (cents) {
      try {
        return (cents / 100).toLocaleString(undefined, { style: 'currency', currency: currency });
      } catch (e) {
        return '$' + (cents / 100).toFixed(2);
      }
    };

    var open = function () {
      overlay.hidden = false;
      panel.hidden = false;
      // doi mot khung hinh, gan .rt-on ngay thi transition khong chay
      requestAnimationFrame(function () {
        overlay.classList.add('rt-on');
        panel.classList.add('rt-on');
      });
      document.body.style.overflow = 'hidden';
    };
    var close = function () {
      overlay.classList.remove('rt-on');
      panel.classList.remove('rt-on');
      document.body.style.overflow = '';
      setTimeout(function () { overlay.hidden = true; panel.hidden = true; }, 280);
    };

    var esc = function (s) {
      return String(s == null ? '' : s)
        .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;');
    };

    var render = function (cart) {
      var body = $('#rt-cart-body');
      var foot = $('#rt-cart-foot');
      if (!cart.items || !cart.items.length) {
        body.innerHTML = '<p class="rt-empty">Your cart is empty.</p>';
        foot.hidden = true;
        return;
      }
      body.innerHTML = cart.items.map(function (i) {
        // xin ban 120px cho nhe: chen _120x truoc duoi file
        var img = i.image ? String(i.image).replace(/(\.[a-z]+)(\?|$)/i, '_120x$1$2') : '';
        var variant = (i.variant_title && i.variant_title !== 'Default Title') ? i.variant_title : '';
        return '<div class="rt-line">' +
          (img ? '<img src="' + esc(img) + '" alt="" loading="lazy">' : '') +
          '<div><h4>' + esc(i.product_title) + '</h4>' +
          (variant ? '<small>' + esc(variant) + '</small><br>' : '') +
          '<small>Qty ' + i.quantity + '</small></div>' +
          '<span class="rt-price">' + money(i.line_price) + '</span>' +
          '</div>';
      }).join('');
      $('#rt-cart-sub').textContent = money(cart.total_price);
      foot.hidden = false;
    };

    var refresh = function () {
      return fetch('/cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(render);
    };

    // Khach bam Back tu checkout: trinh duyet khoi phuc trang tu bfcache voi
    // nut van dang khoa va ghi "GOING TO CHECKOUT..." -> mo khoa lai.
    window.addEventListener('pageshow', function (ev) {
      if (!ev.persisted) return;
      $$('[name="add"]').forEach(function (b) {
        b.disabled = false;
        var t = b.querySelector('.button-text');
        if (t) t.textContent = b.getAttribute('data-original-text') || 'ADD TO CART';
      });
    });

    overlay.addEventListener('click', close);
    var x = $('#rt-cart-x');
    if (x) x.addEventListener('click', close);
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !panel.hidden) close();
    });

    // Chan submit cua MOI form them vao gio. Delegate tren document vi cac
    // section duoc chen dong, gan truc tiep se sot.
    document.addEventListener('submit', function (e) {
      var f = e.target;
      if (!f || f.tagName !== 'FORM') return;
      var action = f.getAttribute('action') || '';
      if (action.indexOf('/cart/add') === -1) return;
      e.preventDefault();

      var btn = f.querySelector('[name="add"]');
      var label = btn ? btn.querySelector('.button-text') : null;
      var old = label ? label.textContent : null;
      if (btn) btn.disabled = true;
      if (label) label.textContent = 'ADDING...';

      var done = function () {
        if (btn) btn.disabled = false;
        if (label && old !== null) label.textContent = old;
      };

      fetch('/cart/add.js', {
        method: 'POST',
        body: new FormData(f),
        headers: { Accept: 'application/json' },
      })
        .then(function (r) {
          return r.json().then(function (d) {
            if (!r.ok) throw new Error(d.description || d.message || 'Could not add to cart');
            return d;
          });
        })
        .then(function () {
          // Them gio thanh cong -> sang thang checkout, bo qua drawer.
          // App bundle (Moonbundle) chan loi goi /cart/add.js o tren va viet
          // lai thanh goi cua no (quantity + thuoc tinh __moonbundle), nen den
          // day dong hang da mang san giam gia -> checkout ap dung duoc.
          // Doi SKIP_CART = false de quay lai mo drawer.
          if (SKIP_CART) {
            if (label) label.textContent = 'GOING TO CHECKOUT...';
            (window.__rtNavigate || function (u) { window.location.assign(u); })('/checkout');
            return;
          }
          return refresh().then(function () { open(); done(); });
        })
        .catch(function (err) {
          $('#rt-cart-body').innerHTML = '<p class="rt-err">' + esc(err.message) + '</p>';
          $('#rt-cart-foot').hidden = true;
          open();
          done();
        });
    }, true);
  }

  // ---------- 4. Nap dan video va anh ----------
  // Ban goc de duong dan trong data-src va nap bang thu vien vanilla-lazyload
  // (new LazyLoad({elements_selector:'.lazy'}), callback_loaded goi play()).
  // Thu vien do do theme nap, da bi go -> dong `new LazyLoad` nem loi, video
  // khong bao gio duoc gan src va dung yen o anh poster.
  //
  // Gan src ngay tu dau cho ca 6 the thi trinh duyet tai 35MB luc mo trang,
  // nen van phai nap dan.

  // Shim o tang thap: bat ky ai goi play() tren mot <video> chua co src ma
  // co data-src thi gan src truoc. Nho vay ca ma GOC cung chay dung -- ke ca
  // video trong modal, thu ma IntersectionObserver khong voi toi duoc vi
  // chung bi an (phan tu an thi khong bao gio "intersect").
  function shimPlay() {
    if (!window.HTMLMediaElement || HTMLMediaElement.prototype.__rtShim) return;
    var orig = HTMLMediaElement.prototype.play;
    HTMLMediaElement.prototype.play = function () {
      if (!this.src && this.dataset && this.dataset.src) {
        this.src = this.dataset.src;
        this.load();
      }
      return orig.apply(this, arguments);
    };
    HTMLMediaElement.prototype.__rtShim = true;
  }

  function initLazy() {
    var SEL = 'video[data-src]:not([data-loaded]), img[data-src]:not([data-loaded]), source[data-src]:not([data-loaded])';

    var load = function (n) {
      if (n.dataset.loaded) return;
      n.dataset.loaded = '1';

      if (n.tagName !== 'VIDEO') {
        n.src = n.dataset.src;
        var p = n.parentNode;
        if (n.tagName === 'SOURCE' && p && p.tagName === 'VIDEO') p.load();
        return;
      }

      // Dat bang THUOC TINH JS chu khong chi tin vao attribute: trinh duyet
      // chi cho autoplay khi video that su dang tat tieng.
      n.muted = true;
      n.playsInline = true;
      n.src = n.dataset.src;
      n.load();

      var tryPlay = function () {
        var pr = n.play();
        if (pr && pr.catch) pr.catch(function () {});
      };
      tryPlay();
      // Goi ngay sau load() co the som hon luc co du du lieu -> thu lai.
      n.addEventListener('canplay', tryPlay, { once: true });
      n.addEventListener('loadeddata', tryPlay, { once: true });
    };

    // TRUY VAN LAI DOM MOI LAN QUET, khong giu danh sach phan tu.
    //
    // Chan doan bang Chrome headless: ham nay nap du 9/9 phan tu ngay lan dau,
    // vay ma sau do video van khong co src. Ly do: file JS co "defer" nen chay
    // TRUOC DOMContentLoaded; sau do handler DOMContentLoaded cua script video
    // goc DUNG LAI khoi video -> ra the <video> moi chi co data-src. Ban cu giu
    // danh sach phan tu cu (da bi thay) va tu dung quet sau lan dau, nen the
    // moi khong ai dung toi. Da "khong" thi phai tim lai tu DOM moi lan.
    var check = function () {
      var vh = window.innerHeight || document.documentElement.clientHeight;
      $$(SEL).forEach(function (n) {
        var r = n.getBoundingClientRect();
        if (r.width > 0 && r.height > 0 && r.top < vh + 300 && r.bottom > -300) load(n);
      });
    };

    var ticking = false;
    var onScroll = function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () { ticking = false; check(); });
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    document.addEventListener('DOMContentLoaded', check);
    window.addEventListener('load', check);
    // Quet dinh ky, KHONG tu dung: noi dung co the bi dung lai bat ky luc nao
    // (script goc, carousel, modal mo ra). Mot querySelectorAll voi selector
    // hep moi giay la khong dang ke.
    setInterval(check, 1000);
    check();
  }
  // ---------- 5. Accordion / FAQ ----------
  // BO HAN. Truoc day o day co mot ham toggle tu viet, va no SAI: trang co
  // hai kieu accordion khac nhau (.faq-item bat class "active" + tinh
  // maxHeight; .store-faq-item bat class "active" theo cum data-accordion)
  // ma ham do chi doi style.display. Bam khong ra gi. Gio dung dung hai
  // script goc, nap trong rt-js.mjs.

  // ---------- 6. Thanh tin giao hang ----------
  // Chi dat NGAY GIAO = hom nay + 2, theo dong ho may khach (khach o mui gio
  // nao thay dung mui gio do).
  //
  // Co Han Quoc va chu "Standard Shipping" nam san trong HTML (rt-build.mjs
  // nhung SVG). JS KHONG duoc dung vao #stbFlag: dat textContent se xoa mat
  // SVG. Ban truoc dat emoji o day va hien thanh chu vo tren trang that.
  function initShipBar() {
    var dateEl = document.getElementById('stbDate');
    if (!dateEl) return;
    var DAY = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
    var MON = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    var d = new Date();
    d.setDate(d.getDate() + 2);   // setDate tu nhay sang thang/nam moi
    dateEl.textContent = DAY[d.getDay()] + ', ' + MON[d.getMonth()] + ' ' + d.getDate();
  }

  // ---------- 7. Nut keu goi mua -> cuon ve ADD TO CART ----------
  // Cac nut "I Want Thicker Hair", "Start Your Transformation"... ban goc dan
  // sang trang san pham (cua roothrive). Gio cuon ve khoi nut mua tren chinh
  // trang nay (href="#rt-buy", rt-build.mjs gan). Dat nut mua vao GIUA man
  // hinh -- nhay dung mep tren thi tren mobile nut dinh sat mep, de bo qua --
  // roi lam noi nut mot nhip de mat khach bat ngay.
  function initScrollToBuy() {
    document.addEventListener('click', function (e) {
      var a = e.target.closest ? e.target.closest('a[data-rt-scroll], a[href="#rt-buy"]') : null;
      if (!a) return;
      var target = document.querySelector('#rt-buy [name="add"]') || document.getElementById('rt-buy');
      if (!target) return;
      e.preventDefault();
      e.stopPropagation();   // khong de script goc cua nut cam ket xu ly them
      target.classList.remove('rt-pulse');
      smoothTo(target, function () {
        void target.offsetWidth;   // reset animation neu bam lien tiep
        target.classList.add('rt-pulse');
      });
    }, true);

    // Tu cuon bang requestAnimationFrame thay vi scrollIntoView({behavior:
    // 'smooth'}): Safari < 15.4 bo qua tuy chon do, va kiem thu tren Chrome
    // headless cho thay no khong chay toi noi (1.6s sau van cach nut mua hang
    // nghin px). Tu cuon thi chac chan toi, va biet LUC NAO toi de moi nhip nut.
    function smoothTo(el, done) {
      var r = el.getBoundingClientRect();
      var start = window.pageYOffset;
      var end = start + r.top - (window.innerHeight / 2 - r.height / 2);
      end = Math.max(0, Math.min(end, document.documentElement.scrollHeight - window.innerHeight));
      var dist = end - start;
      var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (reduce || Math.abs(dist) < 4) { window.scrollTo(0, end); if (done) done(); return; }
      // xa thi lau hon mot chut, nhung khong qua 900ms
      var dur = Math.min(900, 350 + Math.abs(dist) / 12);
      var t0 = null;
      var ease = function (t) { return t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2; };
      var step = function (ts) {
        if (t0 === null) t0 = ts;
        var p = Math.min(1, (ts - t0) / dur);
        window.scrollTo(0, start + dist * ease(p));
        if (p < 1) requestAnimationFrame(step);
        else if (done) done();
      };
      requestAnimationFrame(step);
    }
  }

  // ---------- 8. Menu mobile cua header (homepage) ----------
  // Header theme Elixir/Dawn: <header-drawer><details><summary>. CSS chi hien
  // ngan keo khi <html> co class "js" VA details co class "menu-opening" -- ca
  // hai do JS cua theme gan, ma JS do da bi go -> bam icon menu khong ra gi.
  // Viet lai dung hanh vi do. Trang khong co header-drawer thi bo qua.
  function initHeaderDrawer() {
    var det = document.querySelector('header-drawer details, #Details-menu-drawer-container');
    if (!det) return;
    var sum = det.querySelector('summary');
    var header = det.closest('.header-wrapper') || det.closest('header') || document.body;
    var setBottom = function () {
      var b = header.getBoundingClientRect().bottom;
      document.documentElement.style.setProperty('--header-bottom-position', Math.round(b) + 'px');
    };
    var open = function () {
      setBottom();
      det.setAttribute('open', '');
      requestAnimationFrame(function () { det.classList.add('menu-opening'); });
      if (sum) sum.setAttribute('aria-expanded', 'true');
      document.body.style.overflow = 'hidden';
    };
    var close = function () {
      det.classList.remove('menu-opening');
      if (sum) sum.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
      setTimeout(function () { det.removeAttribute('open'); }, 250);
    };
    if (sum) sum.addEventListener('click', function (e) {
      e.preventDefault();          // tu dieu khien thuoc tinh open, khong de trinh duyet tu bat
      if (det.classList.contains('menu-opening')) close(); else open();
    });
    // bam vao lop phu (ngoai ngan keo) hoac Esc thi dong
    det.addEventListener('click', function (e) {
      if (e.target === det) close();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && det.classList.contains('menu-opening')) close();
    });
    window.addEventListener('resize', function () { if (det.classList.contains('menu-opening')) setBottom(); });
  }

  function boot() {
    safe('header-drawer', initHeaderDrawer);
    safe('scroll-to-buy', initScrollToBuy);
    safe('shim-play', shimPlay);   // phai dat truoc: ma goc se goi play()
    safe('timer', initTimer);
    safe('shipbar', initShipBar);
    safe('cart', initCart);
    safe('lazy', initLazy);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  // Carousel du phong chay SAU cung: phai de script goc khoi tao truoc da.
  window.addEventListener('load', function () { safe('swiper-fallback', initSwipers); });
})();
